var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quantity"},[_c('a',{staticClass:"quantity-btn-minus",on:{"click":_vm.onMinus}},[_vm._v("–")]),_vm._v(" "),_c('input',{staticClass:"quantity-text",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.nowValue.Name}}),_vm._v(" "),_c('a',{staticClass:"quantity-btn-plus",on:{"click":_vm.onPlus}},[_vm._v("＋")])])
}
var staticRenderFns = []

export { render, staticRenderFns }